export const contactRoles = [
  { roleKey: "mainContact", roleLabel: "Main Contact" },
  { roleKey: "agentContact", roleLabel: "Agent Contact" },
  { roleKey: "collectionsContact", roleLabel: "Collections Contact" },
];

export const buildingStatusLabels = {
  Commercial: "Commercial",
  Garage: "Garage",
  Government: "Government",
  Hospital: "Hospital",
  NursingHome: "Nursing Home",
  Other: "Other",
  ParentLocation: "Parent Location",
  ReligiousFacility: "Religious Facility",
  Residential: "Residential",
  Restaurant: "Restaurant",
  School: "School",
  Ship: "Ship",
  TransportationFacility: "Transportation Facility",
};

export const buildingTypeLabels = {
  Active: "Active",
  Cancelled: "Cancelled",
  Collection: "Collection",
  Pending: "Pending",
  Transferred: "Transferred",
  Expired: "Expired",
};

export const contactGeneralFields = [
  { key: "contactName", label: "Name" },
  { key: "contactTitle", label: "Title" },
  { key: "description", label: "Description" },
  { key: "emailAddress", label: "Email" },
  { key: "phone1", label: "Main Phone", type: "phone" },
  { key: "cellPhone", label: "Cell Phone", type: "phone" },
];

export const contactAdditionalFields = [
  { key: "emailAddress2", label: "Secondary Email" },
  { key: "phone2", label: "Secondary Phone", type: "phone" },
  { key: "cellPhone2", label: "Secondary Cell", type: "phone" },
  { key: "faxNumber", label: "Fax Number", type: "phone" },
];

export const initialContactFormData = {
  contactName: "",
  emailAddress: "",
  phone1: "",
  phone2: "",
  faxNumber: "",
  description: "",
  contactTitle: "",
  cellPhone: "",
  cellPhone2: "",
  emailAddress2: "",
};
